import React from 'react';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import useStyles from '../../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';
import { getDpiaBadgeClass, resolveApaDpiaDisplayLabel, resolveDpiaBadgeStatus, type DpiaLabelContext } from '../apaDpiaStatus.helpers';

type ApaDpiaStatusBadgeProps = {
  className?: string;
  status: string;
  dpiaLifecycleStatus?: string | null;
  dpiaRequestStatus?: string | null;
};

const ApaDpiaStatusBadge: React.FC<ApaDpiaStatusBadgeProps> = ({ className, dpiaLifecycleStatus, dpiaRequestStatus, status }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  if (!status) {
    return null;
  }

  const context: DpiaLabelContext = { dpiaLifecycleStatus, dpiaRequestStatus };
  const badgeStatus = resolveDpiaBadgeStatus(status, context);

  return (
    <span className={clsx(styles.dpiaBadge, getDpiaBadgeClass(badgeStatus, styles), className)}>
      {resolveApaDpiaDisplayLabel(status, t, context)}
    </span>
  );
};

export default ApaDpiaStatusBadge;
